import type {
  GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200,
  GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags200,
} from '@fukuri-admins/apis/client/gen/model';
import { getFeatureFlagLabel } from '~/utils/clientFeatureFlagUtils';
import type { EditClientPresentation } from '../../presentations';

type ClientFeatureFlagOption = React.ComponentProps<
  typeof EditClientPresentation
>['clientFeatureFlagOptions'][number];

type IConvertToClientFeatureFlagOptions = (
  clientData: GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200,
  partnerFeatureFlags: GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags200
) => ClientFeatureFlagOption[];

/**
 * APIレスポンスからフィーチャーフラグの選択肢に変換する
 *
 * @param clientData - クライアント詳細APIのレスポンスデータ
 * @param partnerFeatureFlags - パートナーの機能フラグ一覧
 */
export const convertToClientFeatureFlagOptions: IConvertToClientFeatureFlagOptions = (
  clientData,
  partnerFeatureFlags
) =>
  (clientData.client.client_feature_flags ?? []).map(flag => ({
    value: flag.feature_key,
    label: getFeatureFlagLabel(flag.feature_key),
    disabled: !partnerFeatureFlags.partner_feature_flags.some(
      f => f.feature_key === flag.feature_key && f.enabled
    ),
  }));
